import React from 'react'
import './styles.scss'
import HobbiesData from 'data/portfolio/hobbies'
import HobbiesCard from './HobbiesCard'

const Hobbies = () => {
  return (
    <div className="hobbies">
      <div className="frame-hobbies">
        <h3>Our Hobbies</h3>
        <div className="frame-card">
          <HobbiesCard HobbiesData={HobbiesData} />
        </div>
      </div>
    </div>
  )
}

export default Hobbies
